export default {
  exampleAbort: {
    label: `This is a triage abort label`,
    description: `This is a triage abort description`,
  },
};
